import { lazy } from "react";

const Fresh = lazy(() => import("../Component/Leads/Fresh"));
const Picked = lazy(() => import("../Component/Leads/Picked"));
const Details = lazy(() => import("../Component/Leads/Details"));
const DetailsOnce = lazy(() => import("../Component/Leads/DetailsOnce"));
const Interested = lazy(() => import("../Component/Leads/Interested"));
const Doable = lazy(() => import("../Component/Leads/Doable"));
const AddLead = lazy(() => import("../Component/Leads/AddLead"));
const LeadWork = lazy(() => import("../Component/Leads/LeadWork"));
const CommonLeads = lazy(() => import("../Component/Leads/CommonLeads"));
const Working = lazy(() => import("../Component/Leads/Working"));
const LoggedIn = lazy(() => import("../Component/Leads/LoggedIn"));
const UnderReview = lazy(() => import("../Component/Leads/UnderReview"));
const Sanction = lazy(() => import("../Component/Leads/Sanction"));
const Disbursed = lazy(() => import("../Component/Leads/Disbursed"));
const SelfAdded = lazy(() => import("../Component/Leads/SelfAdded"));
const CouldnotConnected = lazy(() => import("../Component/Leads/CouldnotConnected"));
const MapView = lazy(() => import("../Component/Leads/MapView"));
const CamNoteDetails = lazy(() => import("../Component/Leads/CamNoteDetails"));
const CamNoteDetailsForBanker = lazy(() => import("../Component/Leads/CamNoteDetailsForBanker"));
const CamNoteDetailsPage = lazy(() => import("../Component/Leads/CamNoteDetailsPage"));
const LeadList = lazy(() => import("../Component/Leads/LeadList"));
const LeadDetails = lazy(() => import("../Component/CompleteLeadDetailPage/LeadDetails"));
const GeoLocationForm = lazy(() => import("../Component/Leads/GeoLocationForm"));
const CibilReport = lazy(() => import("../Component/Leads/CibilReport"));
const CibilRecordList = lazy(() => import("../Component/Leads/CibilRecordList"));
const CibilReportCustomer = lazy(() => import("../Component/Leads/CibilReportCustomer"));
const CibilGenerateCustomer = lazy(() => import("../Component/Leads/CibilGenerateCustomer"));
const CommonLeadCustomerDetail = lazy(() => import("../Component/Leads/CommonLeadCustomerDetail"));
const PayoutLeadDetailPage = lazy(() => import("../Component/Leads/PayoutLeadDetailPage"));
const BankerSelfUpdate = lazy(() => import("../Component/Leads/BankerSelfUpdate"));
const BankerSelfRegistration = lazy(() => import("../Component/Leads/BankerSelfRegistration"));
const ProductMisMatch = lazy(() => import("../Component/Leads/ProductMisMatch"));

const leadsRoutes = [
  { path: "/assigned-leads", element: <Fresh />, protected: true },
  { path: "/picked-leads", element: <Picked />, protected: true },
  { path: "/add-leads-details/:id", element: <Details />, protected: false },
  { path: "/add-leads-details-once/:id", element: <DetailsOnce />, protected: false },
  { path: "/interested-leads", element: <Interested />, protected: true },
  { path: "/doable-leads", element: <Doable />, protected: true },
  { path: "/add-leads", element: <AddLead />, protected: true },
  { path: "/lead-work/:id", element: <LeadWork />, protected: true },
  { path: "/common-leads", element: <CommonLeads />, protected: true },
  { path: "/working-leads", element: <Working />, protected: true },
  { path: "/logged-in-leads", element: <LoggedIn />, protected: true },
  { path: "/under-review-leads", element: <UnderReview />, protected: true },
  { path: "/sanction-leads", element: <Sanction />, protected: true },
  { path: "/disbursed-leads", element: <Disbursed />, protected: true },
  { path: "/self-added-leads", element: <SelfAdded />, protected: true },
  { path: "/could-not-connected-leads", element: <CouldnotConnected />, protected: true },
  { path: "/map-location/:geoLocation", element: <MapView />, protected: false },
  { path: "/camnote-details", element: <CamNoteDetails />, protected: false },
  { path: "/camnote-details-banker", element: <CamNoteDetailsForBanker />, protected: false },
  { path: "/cam-note-details/:id", element: <CamNoteDetailsPage />, protected: true },
  { path: "/lead-list/:stageId/:dateFilter", element: <LeadList />, protected: true },
  { path: "/lead-details/:leadId", element: <LeadDetails />, protected: true },
  { path: "/geo-location", element: <GeoLocationForm />, protected: false },
  { path: "/cibil-report/:leadId", element: <CibilReport />, protected: false },
  { path: "/cibil-record-list", element: <CibilRecordList />, protected: true },
  { path: "/cibil-report-customer/:id", element: <CibilReportCustomer />, protected: false },
  { path: "/cibil-generate", element: <CibilGenerateCustomer />, protected: true },
  { path: "/customer-detail/:id", element: <CommonLeadCustomerDetail />, protected: true },
  { path: "/payout-lead-detail/:id", element: <PayoutLeadDetailPage />, protected: false },
  { path: "/banker-self-update", element: <BankerSelfUpdate />, protected: false },
  { path: "/banker-self-register", element: <BankerSelfRegistration />, protected: false },
  { path: "/product-mismatch/:leadId/:productId", element: <ProductMisMatch />, protected: true },
];

export default leadsRoutes;
